import React from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { Alert, Button, FormGroup, ControlLabel, Form, Col, FormControl } from 'react-bootstrap';
import { login, logout } from '../actions';

class Login extends React.Component {
  state = {
    redirectToReferrer: false
  }

  login = e => {
    this.props.onLogIn(this.email.value, this.password.value, this.props.firebase);
    e.preventDefault();
  }

  logout = e => {
    this.props.onLogOut(this.props.firebase);
    e.preventDefault();
  }

  render() {
    return (
      <div style={{ paddingTop: '20%', paddingLeft: '40px', paddingRight: '40px' }}>
        <Form horizontal onSubmit={this.login}>
          <FormGroup controlId="formHorizontalEmail">
            <Col componentClass={ControlLabel} sm={2}>
              Email
            </Col>
            <Col sm={4}>
              <FormControl type="email" placeholder="Email" inputRef={(email) => this.email = email} />
            </Col>
          </FormGroup>

          <FormGroup controlId="formHorizontalPassword">
            <Col componentClass={ControlLabel} sm={2}>
              Password
            </Col>
            <Col sm={4}>
              <FormControl type="password" placeholder="Password" inputRef={(password) => this.password = password} />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col smOffset={2} sm={4}>
              <Button type="submit" bsStyle="primary">
                Sign in
              </Button>
            </Col>
          </FormGroup>
        </Form>
        {this.props.logInError ? (<Col smOffset={2} sm={4}>
          <Alert bsStyle="danger">
            {this.props.logInError.message}
          </Alert>
        </Col>) : null}
      </div>
    )
  }
}

export default connect(
  ({ firebase: { authError }, local: { auth: { isLoggingIn, logInError, redirect } } }) => ({
    authError,
    isLoggingIn,
    logInError,
    redirectToReferrer: redirect,
  }),
  ({
    onLogIn: (email, password, firebase) => login(email, password, firebase),
    onLogOut: firebase => logout(firebase),
  })
)(firebaseConnect()(Login))



// WEBPACK FOOTER //
// ./src/components/Login.js